export enum PRODUCT_LOCATION_LABELS {
  BASKET = 'Basket',
  CROSS_SELL = 'Cross-sell',
  MENU = 'Menu',
}

export const ACCOUNT_TABS = {
  GUEST: 'guest',
  SIGN_IN: 'signIn',
  JOIN: 'join',
} as const;
